import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export type ApplovinIconProps = SvgIconProps;

export function ApplovinIcon(props: ApplovinIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 150 150" {...props}>
      <path
        fill="#0599c5"
        d="M142.7,106.53c-4.36-4.6-12.22-6.25-18.18-3.56h0L88.19,37.51l-.11-.24c8.13-10.78,.33-26.56-13.3-26.53-13.45-.14-21.39,15.68-13.42,26.36-.17,.27-36.31,65.47-36.5,65.8-10.54-4.58-23.13,3.79-22.87,15.35,0,9.16,7.43,16.59,16.59,16.59,13.66,.14,21.56-16.13,13.12-26.72,22.38-6.04,62.64-6.13,86.06,.08-8.31,10.62-.41,26.78,13.2,26.64,14.75,.04,22.1-18.09,11.73-28.32Zm-124.01,21.58c-5.42,.02-9.83-4.35-9.85-9.77,.5-13.03,18.92-13.07,19.58-.08h.05c.02,5.42-4.35,9.83-9.77,9.85ZM74.78,17.53c5.41,.03,9.78,4.4,9.81,9.81-.51,13.02-19.11,13.01-19.63,0,0-5.42,4.39-9.81,9.81-9.81ZM34.35,100.32l32.38-58.43v-.03c4.65,2.72,11.29,2.75,15.96,.08l32.42,58.38c-24.72-5.42-58.35-5.18-80.76,0Zm96.67,27.79c-5.42,.02-9.83-4.35-9.85-9.77-.02-5.42,4.35-9.83,9.77-9.85,5.4,0,9.8,4.37,9.85,9.77,.02,5.42-4.35,9.83-9.77,9.85Z"
      />
    </SvgIcon>
  );
}
